import React from 'react'
import { MdFormatListBulleted } from "react-icons/md";
import './GoToQueueButton.css'
import { useNavigate } from 'react-router-dom';
// Correct the function signature to receive props and then destructure to get navigateTo
export function GoToQueueButton({ size = "40px", color = "#D9D9D9"  }) { // Destructure props here
    const navigate = useNavigate()
    const handleClick = () => {
        navigate('/queue'); // This should now correctly refer to the function
    }

    return (
        <button onClick={handleClick} className='queueButton'>
            <MdFormatListBulleted color={color} size={size}/>
        </button>
    );
}
